import { memo } from 'react';
const SvgFileMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="file-minus_svg__feather file-minus_svg__feather-file-minus"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6M9 15h6" />
  </svg>
);
const Memo = memo(SvgFileMinus);
export default Memo;
